import React from "react";

import "./style.css";

import { FaInstagram, FaWhatsapp } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-logo">
          <h2>Leão Truck Parts</h2>
        </div>
        <div className="footer-social">
          <a
            href="https://instagram.com/leaotruckparts"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <FaInstagram />
          </a>
          <a
            href="https://wa.me/5544991419595"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="WhatsApp"
          >
            <FaWhatsapp />
          </a>
        </div>
      </div>
      <div className="footer-copy">
        &copy; {new Date().getFullYear()} Leão Truck Parts. Todos os direitos
        reservados.
      </div>
    </footer>
  );
};

export default Footer;
